import React from 'react'
import { Growth, MetricCardBox, MetricHeader, MetricLabel, MetricMeta, MetricValue, SourceChip } from '../styles'
import { formatNumber, formatPercent } from '../utils'

const MetricCard = ({ metric }) => {
    if (!metric) return null

    const isEvent = metric.source === 'EVENT'
    const growth = metric.growthPercent
    const growthPositive = growth === undefined || growth === null ? null : growth >= 0

    return (
        <MetricCardBox $source={metric.source}>
            <MetricHeader>
                <MetricLabel>{metric.label || metric.key}</MetricLabel>
                <SourceChip
                    size='small'
                    label={isEvent ? 'EVENTO · No período' : 'ESTADO · Total atual'}
                    color={isEvent ? 'success' : 'info'}
                    variant='outlined'
                />
            </MetricHeader>
            <MetricValue>{formatNumber(metric.value)}</MetricValue>
            {isEvent ? (
                <MetricMeta>
                    Anterior: {formatNumber(metric.previousValue)}
                    {' · '}
                    <Growth $positive={growthPositive}>{formatPercent(growth)}</Growth>
                </MetricMeta>
            ) : (
                <MetricMeta>Inventário atual (não comparável a eventos do período)</MetricMeta>
            )}
        </MetricCardBox>
    )
}

export default MetricCard
